import Check from '@mui/icons-material/Check';
import { Box, Button, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Checkbox from '../Checkbox';
import Typography from '../Typography';
import { ListOption } from './types';

export function MenuBody<T extends string | string[] | number = string>({
  color,
  description,
  inputValue,
  isSelectedOption,
  label,
  onClickOnlyButton,
  optionEndAdornment,
  optionStartAdornment,
  value,
}: ListOption & {
  inputValue?: T;
  isSelectedOption: boolean;
  onClickOnlyButton?: (value: T) => void;
}) {
  const theme = useTheme();

  return (
    <>
      <Box display='flex' flexDirection='column' width='100%'>
        {Array.isArray(inputValue) ? (
          <Box display='flex' alignItems='center'>
            {optionStartAdornment && (
              <Box mr={1} display='flex' alignItems='center'>
                {optionStartAdornment}
              </Box>
            )}
            <Checkbox
              checked={inputValue.indexOf(value) > -1}
              aria-label={label}
              padding='4px 12px'
            />
            <ListItemText
              sx={{ flex: 1 }}
              primary={<Typography variant='font14'>{label}</Typography>}
            />
            {onClickOnlyButton && inputValue.indexOf(value) > -1 && (
              <Button
                variant='text'
                onClick={e => {
                  e.stopPropagation();
                  onClickOnlyButton([value] as T);
                }}
                size='small'
                sx={{
                  '&:hover': {
                    backgroundColor: theme.palette.colors.purple[200],
                  },
                  alignItems: 'center',
                  display: 'flex',
                  minWidth: 'fit-content',
                  padding: '3px 4px',
                }}
              >
                <Typography variant='font11'>Only</Typography>
              </Button>
            )}
            {optionEndAdornment && (
              <Box mr={1} display='flex' alignItems='center'>
                {optionEndAdornment}
              </Box>
            )}
          </Box>
        ) : (
          <Box display='flex' alignItems='center'>
            {optionStartAdornment && (
              <Box mr={1} display='flex' alignItems='center'>
                {optionStartAdornment}
              </Box>
            )}
            <Typography
              color={
                isSelectedOption
                  ? theme.palette.primary.main
                  : color || theme.palette.colors.black
              }
              variant='font14'
            >
              {label}
            </Typography>
            {optionEndAdornment && (
              <Box mr={1} display='flex' alignItems='center'>
                {optionEndAdornment}
              </Box>
            )}
          </Box>
        )}
        {description && (
          <Typography variant='font14' color={theme.palette.colors.grey[600]}>
            {description}
          </Typography>
        )}
      </Box>
      {isSelectedOption && <Check sx={{ fill: theme.palette.primary.main }} />}
    </>
  );
}
